module.exports = { id: "stitching", url: "/build/app/img/symbols.svg#stitching", viewBox: "", toString: function() { return this.url; } };